export function getRoleLabel(t, role) {
  if (!role) return '';
  return role
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function buildCategoryTranslationKey(slug) {
  return slug ? `db.category.${slug}` : '';
}